import { t } from "@/i18n-js/instance";
import { ButtonWithDisabled } from "@circle-react-shared/uikit/ButtonWithDisabled/index";
import { Form } from "@circle-react-shared/uikit/Form/index";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";
import { useAddOnsSettingsContext } from "../../../../AddOns/addOnsSettingsContext";
import { ServerErrors } from "../../../../AddOns/ServerErrors";
import { AddOnItem } from "./AddOnItem";
import { GrandfatheredAddonsWarning } from "./GrandfatheredAddonsWarning";

interface ManageAddOnsFormProps {
  onAfterSubmit?: () => void;
}

export const ManageAddOnsForm = ({ onAfterSubmit }: ManageAddOnsFormProps) => {
  const {
    isLoading,
    addOnsData,
    defaultValues,
    onSubmit: onSubmitForm,
    total,
    serverErrors,
    getPlanInterval,
    getPlanCurrency,
    grandfatheredAddonNames,
    handleAddonsMutation: { isLoading: isSubmitting },
  } = useAddOnsSettingsContext();

  const onSubmit = (data: Record<string, number | boolean>) => {
    onSubmitForm(data);
    onAfterSubmit?.();
  };

  return (
    <>
      {isLoading && (
        <div className="flex justify-center py-4">
          <Loader />
        </div>
      )}

      {!isLoading && (
        <div>
          {grandfatheredAddonNames && (
            <GrandfatheredAddonsWarning addonNames={grandfatheredAddonNames} />
          )}

          <Form onSubmit={onSubmit} defaultValues={defaultValues}>
            <div className="text-dark mt-2">
              {serverErrors && <ServerErrors serverErrors={serverErrors} />}

              {addOnsData.map(item => (
                <AddOnItem
                  key={item.slug}
                  name={item.slug}
                  step={item.step}
                  monthlyAmount={item.formatted_base_monthly_amount}
                  toggleable={typeof item.quantity === "boolean"}
                  interval={item.interval}
                  maxPurchasableQuantity={
                    item.max_purchasable_quantity ?? undefined
                  }
                  unitSize={item.unit_size}
                  priceCurrency={item.price_currency}
                />
              ))}

              <div className="my-6 flex justify-between">
                <Typography.LabelLg weight="semibold">
                  {t("settings.billing.add_ons.manage.total_purchase")}
                </Typography.LabelLg>
                <Typography.LabelLg weight="semibold">
                  {`${getPlanCurrency()}${total} ${t("separator_slash")} ${getPlanInterval().charAt(0)}`}
                </Typography.LabelLg>
              </div>

              <div className="my-6">
                <ButtonWithDisabled
                  type="submit"
                  variant="marketing-gradient"
                  large
                  full
                  submitting={isSubmitting}
                >
                  {t("settings.billing.add_ons.manage.apply_changes")}
                </ButtonWithDisabled>
              </div>
            </div>
          </Form>
        </div>
      )}
    </>
  );
};
